var common = require("../utiles/common")

module.exports = {
    register: function () {
        document.createElement('dropmenu')
        ko.components.register('dropmenu', {
            viewModel: function (params) {
                var $this = this;
                $this.isDropMenuDisplay = params.options.isDropMenuDisplay;
                $this.className = params.options.className;
                $this.items = params.options.items;
                $this.activeName = ko.observable();
                $(document).mouseup(function(e){
                    var _con = $(".dropMenu");
                    if(!_con.is(e.target) && _con.has(e.target).length === 0){
                        $this.isDropMenuDisplay(false);
                    }
                });
            },
            template: require("./DropMenu.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/DropMenu.js
// module id = 91
// module chunks = 0